// User Data
const userData = {
  url: `https://lsj1206.github.io/`,
  title: `TECH.log`,
  blog_description: `lsj1206의 개인 기술 블로그 입니다.`,
  name: `lsj1206`,
};

// Giscus (Comment) Config Data
const giscusData = {
  repo: "lsj1206/blog",
  repo_id: "R_kgDONRGoyQ",
  category: "Q&A",
  category_id: "DIC_kwDONRGoyc4ClfH_",
  mapping: "pathname",
  reactions_enabled: "1",
  emit_metadata: "1",
  input_position: "bottom",
  lang: "ko",
};

// Posts List Sorting Table
const SortTable = ["Latest", "Oldest"];

export { giscusData, SortTable };
export default userData;